import React, { useEffect, useState } from 'react'
import { IconUpload } from "@tabler/icons-react";
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Context/store/context';
import { useDispatch, useSelector } from "react-redux";
import { _showToast } from "../../../toastHelper";
import { _get, _post, _put } from '../../../apiClient';
import { servicesList } from '../../Redux/Actions/ServicesListAction';
import globals from '../../../globals';


export default function AddSerices() {

  const userDetails = useSelector((state) => state.admininfo.admininfo);

  const { showLoader, hideLoader, updateTitleAndIcon, getToken, logoutuser } = useAuth();
  const Navigate = useNavigate();
  const [logo, setLogo] = useState("/images/user3.png");
  const [studioName, setStudioName] = useState("");
  const [title, settitle] = useState("");
  const [Servicedescription, setServicedescription] = useState("");
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [serviceId, setServiceId] = useState(0);

  const { id } = useParams();

  useEffect(() => {
    if (!getToken())
      logoutuser();

  }, []);


  useEffect(() => {
    if (userDetails && id) {
      fetchServices(id);
    }
    if (!id) {
      updateTitleAndIcon(globals.addService.title, globals.addService.icon);
    } else
      updateTitleAndIcon(globals.editService.title, globals.editService.icon);

  }, [id, userDetails])

  const handleCancel = async (e) => {
    e.preventDefault();
    return Navigate("/services");
  }


  const handleSave = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!title) validationErrors.title = "Services title is required";
    if (!Servicedescription) validationErrors.Servicedescription = "Services Description is required";
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;
    showLoader();

    let logoImageKey = "";
    if (await saveData(logoImageKey)) {
      await fetchServicesList();
      hideLoader();
      return Navigate("/services");
    }
  };



  const saveData = async (logoImageKey) => {
    let data = {
      "id": serviceId,
      "serviceName": title,
      "description": Servicedescription,
    }
    if (serviceId > 0) {
      return await _put("app-user-services", data)
        .then((response) => {
          _showToast("Service information updated successfully", "success");
          return true;
        }).catch(error => {
          hideLoader();
          _showToast(error, "error");
          return false;
        });
    }
    else {
      return await _post("app-user-services", data)
        .then((response) => {
          _showToast("Service information saved successfully", "success");
          return true;
        }).catch(error => {
          hideLoader();
          _showToast("internal server error please try again", "error");
        dispatch(servicesList(data));

          return false;
        });
    }
  }



  const fetchServices = async (serviceId) => {
    showLoader();

    _get("/app-user-services/" + serviceId)
      .then((service) => {

        if (service.id)
          // setLogo(profile.logo);
        setServiceId(service.id)
        settitle(service.serviceName)
        setServicedescription(service.description)
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
        return Navigate("/services");
      })
  }

  const fetchServicesList = async () => {
    await _get('/app-user-services')
      .then((response) => {
        dispatch(servicesList(response));
      })
      .catch((error) => {
        _showToast(error, "error");
      });
  }


  return (
    <div className="content-wrapper">
    <div className="container-xxl flex-grow-1 container-p-y">
      <div className="card mb-4 pt-2">
        <div className="card-body">
          <form id="formAccountSettings"
           onSubmit={handleSave}
           >
            <div className="row">
            
              <hr className="my-3" />
              <div className="mb-3 col-md-12">
                <label htmlFor="servicetitle" className="form-label">Title Name<span style={{ color: "red", marginLeft: "4px" }}>*</span></label>
                <input type="text" className="form-control" id="servicetitle" name="servicetitle" value={title} placeholder="Enter Your service title here" onChange={(e) => settitle(e.target.value)} />
                {errors.title && <div style={{ color: 'red' }}>{errors.title}</div>}
              </div>
           

              <div className="mb-3 col-md-12">
                <label htmlFor="serviceDiscription" className="form-label">
                Service Discription
                </label>
                <textarea
                  className="form-control"
                  id="serviceDiscription"
                  name="serviceDiscription"
                  placeholder="Enter your service Discription"
                  rows="2"
                  maxLength="500"
                  value={Servicedescription}
                  onChange={(e) => setServicedescription(e.target.value)}
                />
                {errors.Servicedescription && <div style={{ color: 'red' }}>{errors.Servicedescription}</div>}

              </div>

            </div>
            <div className="mt-2">
              <button type="submit" className="btn btn-primary me-2">Save</button>
              <button type="button" className="btn btn-secondary me-2" onClick={handleCancel}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
   
  </div>
  )
}
